import React, { useState, useContext } from 'react';
import { YoutubeOutlined } from '@ant-design/icons';
import { Button, Image } from 'antd';
import YouTube from 'react-youtube';
import './playArea.css'
import { PlayerContext } from '../../../VideoList'

type Props = {
  videoId: string,
  title: string,
  thumbnail: string,
  startAt: number,
  autoplay: boolean
}

function PlayArea(props: Props) {
  const { globalPlayer, setGlobalPlayer } = useContext(PlayerContext);
  const [showYoutube, setShowYoutube] = useState<boolean>(false);

  return (
    <div className='PlayArea'>
      <script src="https://www.youtube.com/iframe_api"></script>
      {showYoutube || props.autoplay ? (
        <YouTube
          key={props.startAt}
          videoId={props.videoId}
          opts={{
            width:'100%',
            playerVars: {autoplay: props.autoplay}
          }}
          onReady={(event) => {
            event.target.seekTo(props.startAt, true)
          }}
          onStateChange={(event) => {
            if (event.data == 1) {
              if (globalPlayer && globalPlayer.g && (globalPlayer.g != event.target.g) ) {
                console.log(event.target);
                console.log(globalPlayer);
                globalPlayer.pauseVideo();
              }
              setGlobalPlayer(event.target);
            }
          }}
        />
      ) : (
        <div className='PlayAreaImg' >
          <Image src={'https://i.ytimg.com/vi_webp/' + props.videoId + '/hqdefault.webp'} width={'100%'} height={'100%'} alt={props.title} />
          <Button 
            className='PlayAreaImgBtn'
            type="primary"
            shape="circle"
            icon={<YoutubeOutlined />}
            size="large"
            onClick={()=>setShowYoutube(true)}
          />
        </div>
      )}
    </div>
  );
}

export default PlayArea
